import styled from 'styled-components';
import { Divider } from 'ui/divider';
import { withFeatureFlag } from 'utils/featureFlagHelpers';
import { HighestCampaignsTable } from './highestCampaignsTable';
import { useTranslation } from '../hooks';
import { AUDIENCE_INSIGHTS_HIGHEST_CAMPAIGNS_FEATURE_FLAG } from '../featureFlags';
import { useConversionInsightsContext } from './contexts';

const Wrapper = styled.div`
  ${({ theme }) => theme.styles.body.body1};
  margin: 0 -${({ theme }) => theme.spacing.values.base} 0 -${({ theme }) =>
    theme.spacing.values.plusHalf};
  padding: 0 ${({ theme }) => theme.spacing.values.base} 0
    ${({ theme }) => theme.spacing.values.plusHalf};
`;

const StyledDivider = styled(Divider)`
  margin-top: 0;
  padding: 0;
`;

const Title = styled.div`
  ${({ theme }) => theme.styles.body.body2};
  font-size: ${({ theme }) => theme.styles.fontSizes.s11};
  line-height: ${({ theme }) => theme.spacing.values.threeQuarter};
  letter-spacing: ${({ theme }) => theme.styles.letterSpacing.pos200};
  font-weight: ${({ theme }) => theme.styles.fontWeights.semiBold};
  color: ${({ theme }) => theme.colors.textColors.textSecondary};
  padding-bottom: ${({ theme }) => theme.spacing.utils.pxToRem(14)};
`;

export const HIGHEST_CAMPAIGNS_DATA_TEST = 'highest-converting-campaign-section';

export const HighestCampaignsSection = withFeatureFlag(
  AUDIENCE_INSIGHTS_HIGHEST_CAMPAIGNS_FEATURE_FLAG,
  () => {
    const { t } = useTranslation();
    const { highestConvertingCampaigns, isLoading } = useConversionInsightsContext();
    const title = t('insights.highestCampaigns');

    return (
      <>
        {!!highestConvertingCampaigns.length && (
          <Wrapper data-test={HIGHEST_CAMPAIGNS_DATA_TEST}>
            <StyledDivider />
            <Title>{title}</Title>
            <HighestCampaignsTable values={highestConvertingCampaigns} isLoading={isLoading} />
          </Wrapper>
        )}
      </>
    );
  },
);
